import moment from 'moment-timezone';

export const FormatTimeFrame = (start, end, timezone) => {
  if (!start || !end) {
    return '';
  }
  const startMomentStr = moment.tz(start, 'HH:mm', timezone).format('h:mma');
  const endMomentStr = moment.tz(end, 'HH:mm', timezone).format('h:mma');
  return `${startMomentStr} - ${endMomentStr}`;
};

export default FormatTimeFrame;
